import { render, staticRenderFns } from "./AccountManagement.vue?vue&type=template&id=664083e8&scoped=true"
import script from "./AccountManagement.vue?vue&type=script&lang=js"
export * from "./AccountManagement.vue?vue&type=script&lang=js"
import style0 from "./AccountManagement.vue?vue&type=style&index=0&id=664083e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664083e8",
  null
  
)

export default component.exports